import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getPAJAB020 } from '../../../services/Api';
import ImageCheckFallback from '../../../shared/components/ImageCheckFallback';
import SideNav from '../../../shared/components/SideNav';
import { BIZ_TYPE_OPTIONS } from '../../../shared/constants/app';
import { formatHomeUrl } from '../../../utils';

const PAJAB010 = () => {
    const [data, setData] = useState([]);
    const [bizType, setBizType] = useState('');

    useEffect(() => {
        getPAJAB020().then(({ data }) => {
            setData(data);
            const code = data.bizType;
            const option = BIZ_TYPE_OPTIONS.find((option) => option.code === code);

            setBizType(option?.codeName);
        });
    }, []);

    return (
        <div id="content" className="sub-page">
            <div className="container">
                <div id="top-sub-page">
                    <SideNav />
                    <div className="resume" id="resume_CV">
                        <div className="resume__inner">
                            <h3 className="resume__tit">치과 정보 관리</h3>
                            <div className="rsm-dtl">
                                <div className="resume__tit-box mb12">
                                    <h4 className="resume__tit2">치과 정보</h4>
                                </div>
                                <table className="rsm-dtl__table rsm-dtl__table--ver2 wd170">
                                    <tbody>
                                        <tr>
                                            <th>치과명</th>
                                            <td>{data?.bizCompany}</td>
                                            <th>사업장 구분</th>
                                            <td className="wd36per">{bizType}</td>
                                        </tr>
                                        <tr>
                                            <th>대표자명</th>
                                            <td>{data?.nameKor}</td>
                                            <th>홈페이지</th>
                                            <td>
                                                {formatHomeUrl(data?.homepageUrl) ? (
                                                    <a
                                                        style={{ cursor: 'pointer' }}
                                                        href={formatHomeUrl(data?.homepageUrl)}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        {data?.homepageUrl}
                                                    </a>
                                                ) : (
                                                    <span>{data?.homepageUrl}</span>
                                                )}
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>주소</th>
                                            <td className="pd0" colSpan={3}>
                                                <div className="dntInf__adr">
                                                    <span>
                                                        ({data?.postNo}) {data?.addressRoad} {data?.addressDetail}
                                                    </span>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div className="resume__tit-box mb12">
                                    <h4 className="resume__tit2">치과 소개</h4>
                                </div>
                                <table className="rsm-dtl__table rsm-dtl__table--ver2 wd170">
                                    <tbody>
                                        <tr>
                                            <th>치과 로고</th>
                                            <td>
                                                {data?.logoName && (
                                                    <div className="dntInf__glr">
                                                        <div className="dntInf__imgbox dntInf__imgbox--logo">
                                                            <ImageCheckFallback
                                                                folderName={'recruit_logo'}
                                                                imgName={data?.logoName}
                                                                alt="Recruit Logo"
                                                                classImg={'dntInf__logo'}
                                                            />
                                                        </div>
                                                    </div>
                                                )}
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>치과 이미지</th>
                                            <td>
                                                <div className="dntInf__glr">
                                                    {data?.subBizImg &&
                                                        data?.subBizImg.split('|').map((item, index) => (
                                                            <div
                                                                className="dntInf__imgbox"
                                                                key={'recruit-organization' + index}
                                                            >
                                                                <ImageCheckFallback
                                                                    folderName={'recruit_photo'}
                                                                    imgName={item}
                                                                    alt="Organization"
                                                                />
                                                            </div>
                                                        ))}
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>총 구성원수</th>
                                            <td>{data?.centerStaffCount ? `${data?.centerStaffCount} 명` : ''}</td>
                                        </tr>
                                        <tr>
                                            <th>구성원 설명</th>
                                            <td className="pre-line">{data?.memberDesc}</td>
                                        </tr>
                                        <tr>
                                            <th>치과소개</th>
                                            <td className="hi260 pre-line">{data?.centerDesc}</td>
                                        </tr>
                                    </tbody>
                                </table>

                                <div className="dntInf__btbx">
                                    <Link className="dntInf__btn" to="/pajab020">
                                        치과정보 수정
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default PAJAB010;
